import React from 'react';
import { withStyles } from '@material-ui/core';

const styles = (theme) => ({
  root: {
    minHeight: 600,
    paddingBottom: theme.spacing(10),
    backgroundColor: '#ffffff',
  },
});

class Container extends React.Component {
  render() {
    const { classes, children } = this.props;
    return (
      <div id="main_container" className={classes.root}>
        {children}
      </div>
    );
  }
}

export default withStyles(styles, { withTheme: true })(Container);
